<template>
  <ProcessMethod/>
</template>
<script>
import ProcessMethod from 'operations/workorder/processMethod.vue'
export default {
    components:{
      ProcessMethod
    }
}
</script>